var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      attrs: {
        "body-style": { padding: "20px" },
        shadow: "never",
        bordered: false,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.grid, false),
            [
              !_vm.isAuto
                ? _c(
                    "el-form-item",
                    { attrs: { label: "奖品类型：", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            disabled:
                              _vm.disabled || (_vm.type === 6 && _vm.isEdit),
                            size: "small",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.value.prizeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeType", $$v)
                            },
                            expression: "value.prizeType",
                          },
                        },
                        _vm._l(_vm.prizeTypeOptions, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "奖项名称：", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入奖项名称",
                      disabled: _vm.isAuto || _vm.disabled || _vm.type === 6,
                    },
                    model: {
                      value: _vm.value.awardName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "awardName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.awardName",
                    },
                  }),
                ],
                1
              ),
              _vm.value.prizeType === 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品名称：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品名称",
                            disabled: _vm.isAuto || _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品图片：", required: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox acea-row",
                            on: { click: _vm.modalPicTap },
                          },
                          [
                            _vm.value.prizePic
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.value.prizePic },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("建议尺寸：400*400px，上传小于500kb的图片"),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品库存：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入库存",
                          },
                          model: {
                            value: _vm.value.prizeNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeNum", $$v)
                            },
                            expression: "value.prizeNum",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赠送积分值：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入赠送积分值",
                          },
                          model: {
                            value: _vm.value.pointsValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "pointsValue", $$v)
                            },
                            expression: "value.pointsValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm.value.prizeType === 2
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品名称：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品名称",
                            disabled: _vm.isAuto || _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品标题：" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品标题",
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeTitle,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeTitle",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品图片：", required: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox acea-row",
                            on: { click: _vm.modalPicTap },
                          },
                          [
                            _vm.value.prizePic
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.value.prizePic },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("建议尺寸：400*400px，上传小于500kb的图片"),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品库存：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入库存",
                          },
                          model: {
                            value: _vm.value.prizeNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeNum", $$v)
                            },
                            expression: "value.prizeNum",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品价格：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: 0.01,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入价格",
                          },
                          model: {
                            value: _vm.value.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "price", $$v)
                            },
                            expression: "value.price",
                          },
                        }),
                        _vm._v("元 "),
                      ],
                      1
                    ),
                  ]
                : _vm.value.prizeType === 3
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品名称：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品名称",
                            disabled: _vm.isAuto || _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品图片：", required: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox acea-row",
                            on: { click: _vm.modalPicTap },
                          },
                          [
                            _vm.value.prizePic
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.value.prizePic },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("建议尺寸：400*400px，上传小于500kb的图片"),
                        ]),
                      ]
                    ),
                    _vm.type === 5
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "首抽必中：", required: "" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "是",
                                "inactive-text": "否",
                              },
                              on: { change: _vm.winFlagChange },
                              model: {
                                value: _vm.value.winFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "winFlag", $$v)
                                },
                                expression: "value.winFlag",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品数量：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入数量",
                          },
                          model: {
                            value: _vm.value.prizeNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeNum", $$v)
                            },
                            expression: "value.prizeNum",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.type === 6
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "发放方式：", required: "" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  disabled: _vm.disabled,
                                  size: "small",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.value.grantMethod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "grantMethod", $$v)
                                  },
                                  expression: "value.grantMethod",
                                },
                              },
                              _vm._l(
                                _vm.grantMethodOptions,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "红包金额：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: 0.01,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入金额",
                          },
                          model: {
                            value: _vm.value.redPacketPrice,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "redPacketPrice", $$v)
                            },
                            expression: "value.redPacketPrice",
                          },
                        }),
                        _vm._v("元 "),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("每个中奖用户领取的金额"),
                        ]),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("预计总发放金额：" + _vm._s(_vm.total) + "元"),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm.value.prizeType === 4
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择商品：", required: "" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "from-ipt-width",
                            attrs: {
                              value: _vm.value.productId
                                ? "(" +
                                  _vm.value.productId +
                                  ") " +
                                  _vm.value.productName
                                : "",
                              readonly: "",
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "append" },
                              [
                                _c("el-button", {
                                  attrs: { icon: "el-icon-search" },
                                  on: { click: _vm.handleSelectProduct },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品数量：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入数量",
                          },
                          model: {
                            value: _vm.value.prizeNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeNum", $$v)
                            },
                            expression: "value.prizeNum",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品名称：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品名称",
                            disabled: _vm.isAuto || _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品图片：", required: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox acea-row",
                            on: { click: _vm.modalPicTap },
                          },
                          [
                            _vm.value.prizePic
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.value.prizePic },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("建议尺寸：400*400px，上传小于500kb的图片"),
                        ]),
                      ]
                    ),
                  ],
              _vm.type !== 6
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "中奖概率：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: 0.01,
                            disabled: _vm.isAuto || _vm.disabled,
                            "controls-position": "right",
                            controls: _vm.value.prizeType !== 99,
                            "step-strictly": "",
                            placeholder: "请输入中奖概率",
                          },
                          on: {
                            change: _vm.checkWinProbability,
                            input: _vm.checkWinProbability,
                          },
                          model: {
                            value: _vm.value.winProbability,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "winProbability", $$v)
                            },
                            expression: "value.winProbability",
                          },
                        }),
                        _vm._v(" % "),
                      ],
                      1
                    ),
                    _vm.value.prizeType !== 99
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "每人中奖次数：", required: "" } },
                          [
                            _c("el-input-number", {
                              attrs: {
                                min: 1,
                                step: 1,
                                disabled: _vm.disabled,
                                "controls-position": "right",
                                "step-strictly": "",
                                placeholder: "请输入数量",
                              },
                              model: {
                                value: _vm.value.userWinLimit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "userWinLimit", $$v)
                                },
                                expression: "value.userWinLimit",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v("每人最多抽中本奖项次数"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }